import React, { useState } from "react";
import { database, ref, push } from "./firebaseConfig";

function GetaQuote() {
  const [formData, setFormData] = useState({
    service: "",
    name: "",
    email: "",
    phone: "",
    details: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const services = [
    "Eco Home Consultation",
    "Sustainable Landscaping",
    "Solar Panel Installation",
    "Waste Reduction Planning",
    "Green Product Supply",
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    // ..formData -> keep everything thats in the form
    // e.target... -> but change the target name
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await push(ref(database, "Quotes"), formData);
      setSubmitted(true);
      setFormData({
        service: "",
        name: "",
        email: "",
        phone: "",
        details: "",
      });
    } catch (error) {
      console.error("Error submitting form: ", error);
    }
  };

  return (
    <section
      style={{
        background: "rgb(248, 253, 236)",
        minHeight: "100vh",
        padding: "3rem 1rem",
        color: "#1d4130",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "600px",
          margin: "100px auto",
          background: "rgba(255, 255, 255, 0.9)",
          padding: "2rem",
          borderRadius: "15px",
          boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
        }}
      >
        <h1
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-duration="1500"
          style={{ textAlign: "center", marginBottom: "1rem" }}
        >
          Get a Quote 🌿
        </h1>

        {!submitted ? (
          <form
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="1500"
            onSubmit={handleSubmit}
          >
            <label
              htmlFor="service"
              style={{
                display: "block",
                marginTop: "30px",
                fontWeight: "600",
              }}
            >
              Select Service:
            </label>
            <select
              id="service"
              name="service"
              value={formData.service}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "0.5rem",
                marginBottom: "1rem",
                borderRadius: "8px",
                border: "2px solid #56ab2f",
                fontSize: "1rem",
              }}
            >
              <option value="" disabled>
                -- Choose a service --
              </option>
              {services.map((service, index) => (
                <option key={index} value={service}>
                  {service}
                </option>
              ))}
            </select>

            <label
              htmlFor="name"
              style={{
                display: "block",
                marginBottom: ".5rem",
                fontWeight: "600",
              }}
            >
              Name:
            </label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Your full name"
              value={formData.name}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "0.5rem",
                marginBottom: "1rem",
                borderRadius: "8px",
                border: "2px solid #56ab2f",
                fontSize: "1rem",
              }}
            />

            <label
              htmlFor="email"
              style={{
                display: "block",
                marginBottom: ".5rem",
                fontWeight: "600",
              }}
            >
              Email:
            </label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Your email address"
              value={formData.email}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "0.5rem",
                marginBottom: "1rem",
                borderRadius: "8px",
                border: "2px solid #56ab2f",
                fontSize: "1rem",
              }}
            />

            <label
              htmlFor="phone"
              style={{
                display: "block",
                marginBottom: ".5rem",
                fontWeight: "600",
              }}
            >
              Phone:
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              placeholder="Your phone number"
              value={formData.phone}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "0.5rem",
                marginBottom: "1rem",
                borderRadius: "8px",
                border: "2px solid #56ab2f",
                fontSize: "1rem",
              }}
            />

            <label
              htmlFor="details"
              style={{
                display: "block",
                marginBottom: ".5rem",
                fontWeight: "600",
              }}
            >
              Additional Details:
            </label>
            <textarea
              id="details"
              name="details"
              placeholder="Tell us more about your project or questions"
              value={formData.details}
              onChange={handleChange}
              rows={4}
              style={{
                width: "100%",
                padding: "0.5rem",
                marginBottom: "1.5rem",
                borderRadius: "8px",
                border: "2px solid #56ab2f",
                fontSize: "1rem",
                resize: "vertical",
              }}
            ></textarea>

            <button
              type="submit"
              style={{
                width: "100%",
                padding: "0.75rem",
                backgroundColor: "#1d4130",
                color: "white",
                fontWeight: "700",
                fontSize: "1.1rem",
                border: "none",
                borderRadius: "12px",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#14501c")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "#1d4130")
              }
            >
              Get Quote
            </button>
          </form>
        ) : (
          <div
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="1500"
            style={{ textAlign: "center" }}
          >
            <h2>Thank you for reaching out!</h2>
            <p>We will contact you soon with your personalized quote 🌿</p>
          </div>
        )}
      </div>
    </section>
  );
}

export default GetaQuote;
